"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3497],{

/***/ 32095:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15313);
/* harmony import */ var redux_api_reselect_profile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95293);




function TopBar() {
    var languageCode = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.config;
    }).languageCode;
    var customerType = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(redux_api_reselect_profile__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).customerType;
    return languageCode === "REMOVED" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "sl-top-bar",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "sl-top-bar-container",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "sl-top-bar-content",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: "Su Ready sconto del 20% su tutti i servizi editoriali, approfittane subito! Promo valida fino a venerd\xec 18 novembre 2022"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "sl-top-bar-actions",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "https://readybooks.io",
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: "Vai su Ready"
                        })
                    })
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (TopBar);


/***/ }),

/***/ 42805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ warning_notification; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(32016);
// EXTERNAL MODULE: ./node_modules/@styled-system/theme-get/dist/index.esm.js
var dist_index_esm = __webpack_require__(50056);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(15313);
// EXTERNAL MODULE: ./src/redux/action/warning.js
var warning = __webpack_require__(6482);
// EXTERNAL MODULE: ./src/redux/reselect/profile.js
var profile = __webpack_require__(95293);
// EXTERNAL MODULE: ./src/redux/reselect/warning.js
var reselect_warning = __webpack_require__(97998);
// EXTERNAL MODULE: ./src/theme/text/index.js
var theme_text = __webpack_require__(5799);
// EXTERNAL MODULE: ./src/theme/icons/alert.js
var icons_alert = __webpack_require__(88176);
;// CONCATENATED MODULE: ./src/theme/icons/hide.js


function Hide() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "16",
        height: "15",
        viewBox: "0 0 16 15",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M5.05475 7.50925L2.159 4.6135C1.019 5.85625 0.587 7.10125 0.5795 7.12675L0.5 7.36375L0.57875 7.60075C0.59525 7.651 2.31575 12.6137 8.0405 12.6137C8.73725 12.6137 9.37175 12.5372 9.9545 12.409L7.895 10.3495C7.15346 10.3131 6.45196 10.0022 5.92699 9.47726C5.40201 8.95228 5.0911 8.25078 5.05475 7.50925ZM8.0405 2.11375C6.64925 2.11375 5.50925 2.41675 4.559 2.86225L1.78025 0.0834961L0.71975 1.144L14.2197 14.644L15.2803 13.5835L12.8068 11.11C14.7853 9.64525 15.491 7.63225 15.5015 7.60075L15.5802 7.36375L15.5015 7.12675C15.485 7.0765 13.7653 2.11375 8.0405 2.11375ZM9.47 7.77324C9.61025 7.26549 9.491 6.694 9.101 6.30325C8.711 5.9125 8.13875 5.794 7.631 5.93425L6.5 4.80325C6.96347 4.51823 7.49641 4.36619 8.0405 4.36375C9.695 4.36375 11.0405 5.70925 11.0405 7.36375C11.0383 7.90773 10.8859 8.44055 10.6003 8.9035L9.47 7.77324Z",
            fill: "currentColor"
        })
    });
}
/* harmony default export */ var hide = (Hide);

// EXTERNAL MODULE: ./src/translations/index.js + 4 modules
var translations = __webpack_require__(99408);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./src/components/warning-notification/index.js



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  display: ",
        ";\n  width: 100%;\n  border-radius: 12px;\n\n  & > .head {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n\n    & > div {\n      display: flex;\n      flex-direction: row;\n    }\n\n    & > div > span {\n      color: ",
        ";\n    }\n  }\n\n  & > .notification {\n    border-radius: 4px;\n    border: 1px solid ",
        ";\n    background: ",
        ";\n    border-left: 4px solid ",
        ";\n    padding: ",
        "px;\n    margin: ",
        "px 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c4ef63db-0"
})(_templateObject(), index_esm/* space */.Dh, function(param) {
    var isVisible = param.isVisible;
    return isVisible ? "block" : "none";
}, (0,dist_index_esm/* themeGet */.R)("colors.warning"), (0,dist_index_esm/* themeGet */.R)("colors.accent"), (0,dist_index_esm/* themeGet */.R)("colors.white"), (0,dist_index_esm/* themeGet */.R)("colors.warning"), (0,dist_index_esm/* themeGet */.R)("space.xs"), (0,dist_index_esm/* themeGet */.R)("space.xs"));
function WarningNotification(param) {
    var style = param.style, className = param.className;
    var dispatch = (0,es/* useDispatch */.I0)();
    var languageCode = (0,es/* useSelector */.v9)(function(state) {
        return state.config;
    }).languageCode;
    var isVisible = (0,es/* useSelector */.v9)(function(state) {
        return state.warning;
    }).isVisible;
    var warnings = (0,es/* useSelector */.v9)(reselect_warning/* default */.Z);
    (0,react.useEffect)(function() {
        dispatch((0,warning/* getWarningRequest */.jT)());
    }, [
        dispatch
    ]);
    var handleClose = (0,react.useCallback)(function() {
        dispatch((0,warning/* setWarningVisible */.Ic)(false));
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        isVisible: isVisible && warnings.length
    }, style), {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "head",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_alert/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_text/* default */.Z, {
                                fontSize: "h4",
                                lineHeight: "h4",
                                fontWeight: "bold",
                                color: "grey_600",
                                ml: "10px",
                                children: translations/* default */.Z[languageCode].warning
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        title: translations/* default */.Z[languageCode].warning,
                        type: "button",
                        onClick: handleClose,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(hide, {})
                    })
                ]
            }),
            warnings.map(function(param) {
                var key = param.key, message = param.message;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "notification",
                    children: message
                }, key);
            })
        ]
    }));
}
/* harmony default export */ var warning_notification = (WarningNotification);


/***/ }),

/***/ 60873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ capitalizeFirstLetter; },
/* harmony export */   "i": function() { return /* binding */ formatDateString; }
/* harmony export */ });
var capitalizeFirstLetter = function(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
};
var formatDateString = {
    it: "DD MMM",
    pt: "DD MMM",
    de: "DD MMM",
    en: "MMM DD"
};



/***/ }),

/***/ 3411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ selectBillingFormErrors; },
/* harmony export */   "Hj": function() { return /* binding */ selectDocumentPassive; },
/* harmony export */   "LI": function() { return /* binding */ selectDocumentActive; },
/* harmony export */   "LQ": function() { return /* binding */ selectPaymentFormErrors; },
/* harmony export */   "aE": function() { return /* binding */ selectDocuments; },
/* harmony export */   "gB": function() { return /* binding */ selectLastWithdrawal; },
/* harmony export */   "pV": function() { return /* binding */ selectBillingProfiles; },
/* harmony export */   "ur": function() { return /* binding */ selectPaymentAccounts; },
/* harmony export */   "wO": function() { return /* binding */ selectDefaultBillingProfile; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29815);
/* harmony import */ var lib_format_currency__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70351);
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68697);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(25934);
/* harmony import */ var translations__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99408);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57708);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60873);
/* eslint-disable prefer-destructuring */ /* eslint-disable no-nested-ternary */ /* eslint-disable camelcase */ 










var formatDate = "MMMM YYYY";
var selectSummary = (0,reselect__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(function(state) {
    return state.billing.summary;
}, _config__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, function(payload, param) {
    var languageCode = param.languageCode;
    if (!payload) {
        return {
            nextInvoicing: null,
            availableBalance: null,
            totalEarned: null,
            lastEarned: null,
            earningsPercentage: null,
            temporaryRevenuesNotBilled: null,
            estimatedPaymentOn: null
        };
    }
    var _attributes = payload.attributes, balanceAvailable = _attributes.balanceAvailable, totalEarned = _attributes.totalEarned, lastEarned = _attributes.lastEarned, nextInvoiceOn = _attributes.nextInvoiceOn, temporaryRevenuesNotBilled = _attributes.temporaryRevenuesNotBilled, invoicingPeriodCode = _attributes.invoicingPeriodCode, estimatedPaymentOn = _attributes.estimatedPaymentOn, paymentTerm = _attributes.paymentTerm;
    moment__WEBPACK_IMPORTED_MODULE_0___default().locale(languageCode);
    var _percentageDiff;
    return {
        nextInvoicing: nextInvoiceOn ? (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .f)(moment__WEBPACK_IMPORTED_MODULE_0___default()(nextInvoiceOn, "YYYY-MM-GG").format(formatDate)) : translations__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z[languageCode]["no available"],
        invoicingPeriodCode: translations__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z[languageCode][invoicingPeriodCode],
        availableBalance: balanceAvailable.amount ? (0,lib_format_currency__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(balanceAvailable.currency, balanceAvailable.amount) : translations__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z[languageCode]["no available"],
        totalEarned: totalEarned.amount ? (0,lib_format_currency__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(totalEarned.currency, totalEarned.amount) : translations__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z[languageCode]["no available"],
        lastEarned: lastEarned.amount ? (0,lib_format_currency__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(lastEarned.currency, lastEarned.amount) : translations__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z[languageCode]["no available"],
        earningsPercentage: (_percentageDiff = lastEarned.percentageDiff) !== null && _percentageDiff !== void 0 ? _percentageDiff : 0,
        temporaryRevenuesNotBilled: temporaryRevenuesNotBilled.amount ? (0,lib_format_currency__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(temporaryRevenuesNotBilled.currency, temporaryRevenuesNotBilled.amount) : translations__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z[languageCode]["no available"],
        estimatedPaymentOn: estimatedPaymentOn ? (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .f)(moment__WEBPACK_IMPORTED_MODULE_0___default()(estimatedPaymentOn, "YYYY-MM-GG").format(formatDate)) : translations__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z[languageCode]["no available"],
        paymentTerm: paymentTerm && paymentTerm.code ? translations__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z[languageCode][paymentTerm.code] : translations__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z[languageCode]["no available"]
    };
});
var selectDocuments = (0,reselect__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(function(state) {
    return state.billing.documents;
}, _config__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, function(payload, param) {
    var languageCode = param.languageCode;
    if (!payload) return {
        data: [],
        totalCount: 0
    };
    moment__WEBPACK_IMPORTED_MODULE_0___default().locale(languageCode);
    var data = payload.data, meta = payload.meta;
    var formattedData = data.map(function(invoice) {
        var id = invoice.id, attributes = invoice.attributes;
        var periods = [];
        if (attributes.sumAmountsByPeriods) {
            periods = attributes.sumAmountsByPeriods.map(function(param) {
                var periodCode = param.periodCode;
                return moment__WEBPACK_IMPORTED_MODULE_0___default()(periodCode, "YYYY-MM").format("MM-YYYY");
            });
        }
        var _amount;
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, attributes), {
            key: id,
            id: id,
            issuedOn: attributes.issuedOn ? moment__WEBPACK_IMPORTED_MODULE_0___default()(attributes.issuedOn).format("DD MMM YYYY") : "",
            approvedOn: attributes.approvedOn ? moment__WEBPACK_IMPORTED_MODULE_0___default()(attributes.approvedOn).format("DD MMM YYYY") : attributes.issuedOn ? moment__WEBPACK_IMPORTED_MODULE_0___default()(attributes.issuedOn).format("DD MMM YYYY") : "-",
            paidOn: attributes.paidOn ? moment__WEBPACK_IMPORTED_MODULE_0___default()(attributes.paidOn).format("DD MMM YYYY") : null,
            amount: (0,lib_format_currency__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(attributes.currencyCode, (_amount = attributes.amount) !== null && _amount !== void 0 ? _amount : 0),
            periods: periods
        });
    });
    return {
        data: formattedData,
        totalCount: meta.totalCount
    };
});
var selectPaymentAccounts = (0,reselect__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(function(state) {
    return state.billing.paymentAccounts;
}, function(payload) {
    if (!payload) return {
        total: 0,
        totalDraft: 0,
        paymentAccounts: []
    };
    var data = payload.data;
    return {
        total: data.length,
        totalDraft: 0,
        paymentAccounts: data.map(function(param) {
            var attributes = param.attributes, _relationships = param.relationships, billingProfiles = _relationships.billingProfiles, tokenRel = _relationships.token;
            var ref;
            var pid = attributes.pid, label = attributes.label, paymentMethodCode = attributes.paymentMethodCode, bankName = attributes.bankName, ownerName = attributes.ownerName, iban = attributes.iban, bic = attributes.bic, accountNumber = attributes.accountNumber, routingNumber = attributes.routingNumber, paypal = attributes.paypal, payoneer = attributes.payoneer, payoneerInternal = attributes.payoneerInternal, sureRemitWallet = attributes.sureRemitWallet, sureRemitMemo = attributes.sureRemitMemo, countryCode = attributes.countryCode, createdAt = attributes.createdAt, updatedAt = attributes.updatedAt, verified = attributes.verified;
            var ref1;
            var tokenPid = (ref1 = tokenRel === null || tokenRel === void 0 ? void 0 : (ref = tokenRel.data) === null || ref === void 0 ? void 0 : ref.id) !== null && ref1 !== void 0 ? ref1 : null;
            return {
                id: pid,
                label: label,
                paymentMethodCode: paymentMethodCode,
                isDraft: false,
                verified: verified !== null && verified !== void 0 ? verified : true,
                tokenPid: tokenPid,
                billingProfilesIds: billingProfiles.data ? billingProfiles.data.map(function(param) {
                    var id = param.id;
                    return id;
                }) : [],
                billingProfilesCounter: billingProfiles && billingProfiles.data ? billingProfiles.data.length : 0,
                bankName: bankName,
                ownerName: ownerName,
                iban: iban,
                bic: bic,
                accountNumber: accountNumber,
                routingNumber: routingNumber,
                paypal: paypal,
                payoneer: payoneer,
                payoneerInternal: payoneerInternal,
                sureRemitWallet: sureRemitWallet,
                sureRemitMemo: sureRemitMemo,
                countryCode: countryCode,
                createdAt: createdAt ? moment__WEBPACK_IMPORTED_MODULE_0___default()(createdAt, "YYYY-MM-DD").format("L") : "",
                updatedAt: updatedAt ? moment__WEBPACK_IMPORTED_MODULE_0___default()(updatedAt, "YYYY-MM-DD").format("L") : ""
            };
        }).sort(function(a, b) {
            return "".concat(a.paymentMethodCode).localeCompare(b.paymentMethodCode) || "".concat(a.label).localeCompare(b.label);
        })
    };
});
var selectBillingProfiles = (0,reselect__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(function(state) {
    return state.billing.profiles;
}, selectPaymentAccounts, function(payload, param) {
    var paymentAccounts = param.paymentAccounts;
    if (!payload) return {
        total: 0,
        totalDraft: 0,
        profiles: []
    };
    var data = payload.data;
    var totalDraft = 0;
    data.forEach(function(profile) {
        var validForPassiveInvoice = profile.attributes.validForPassiveInvoice;
        if (!validForPassiveInvoice) totalDraft += 1;
    });
    return {
        total: data.length,
        totalDraft: totalDraft,
        profiles: data.map(function(param) {
            var attributes = param.attributes, _relationships = param.relationships, paymentAccountRel = _relationships.paymentAccount;
            var pid = attributes.pid, label = attributes.label, appellation = attributes.appellation, isDefault = attributes.default, billingModeCode = attributes.billingModeCode, countryEu = attributes.countryEu, firstName = attributes.firstName, lastName = attributes.lastName, bornOn = attributes.bornOn, birthPostalCode = attributes.birthPostalCode, birthCity = attributes.birthCity, birthCountrySub = attributes.birthCountrySub, birthCountry = attributes.birthCountry, sex = attributes.sex, address = attributes.address, addressAlt = attributes.addressAlt, city = attributes.city, personalTin = attributes.personalTin, companyTin = attributes.companyTin, countrySub = attributes.countrySub, countryCode = attributes.countryCode, recipientCode = attributes.recipientCode, postalCode = attributes.postalCode, email = attributes.email, phone = attributes.phone, vatModeCode = attributes.vatModeCode, validForPassiveInvoice = attributes.validForPassiveInvoice, validationPassiveInvoiceErrors = attributes.validationPassiveInvoiceErrors, validForActiveInvoice = attributes.validForActiveInvoice, validationActiveInvoiceErrors = attributes.validationActiveInvoiceErrors, withheldCode = attributes.withheldCode, pensionModeCode = attributes.pensionModeCode, pensionInstitute = attributes.pensionInstitute, createdAt = attributes.createdAt, updatedAt = attributes.updatedAt;
            var paymentAccount = {};
            var paymentId = null;
            if (paymentAccountRel && paymentAccountRel.data && paymentAccountRel.data.id) {
                paymentId = paymentAccountRel.data.id;
                var paymentAccountFinded = paymentAccounts.find(function(param) {
                    var id = param.id;
                    return paymentAccountRel.data.id === id;
                });
                if (paymentAccountFinded) {
                    paymentAccount = paymentAccountFinded;
                }
            }
            return {
                id: pid,
                label: label,
                appellation: appellation,
                isDefault: isDefault,
                billingModeCode: billingModeCode,
                countryEu: countryEu,
                recipientCode: recipientCode,
                bornOn: bornOn ? moment__WEBPACK_IMPORTED_MODULE_0___default()(bornOn, "YYYY-MM-DD") : null,
                birthPostalCode: birthPostalCode,
                birthCity: birthCity,
                birthCountrySub: birthCountrySub,
                birthCountry: birthCountry,
                sex: sex,
                firstName: firstName,
                lastName: lastName,
                address: address,
                addressAlt: addressAlt,
                city: city,
                personalTin: personalTin,
                companyTin: companyTin,
                countrySub: countrySub,
                countryCode: !countryCode ? null : countryCode,
                postalCode: postalCode,
                email: email,
                phone: phone,
                vatModeCode: vatModeCode,
                pensionModeCode: pensionModeCode,
                pensionInstitute: pensionInstitute,
                validForPassiveInvoice: validForPassiveInvoice,
                validationPassiveInvoiceErrors: validationPassiveInvoiceErrors,
                validForActiveInvoice: validForActiveInvoice,
                validationActiveInvoiceErrors: validationActiveInvoiceErrors,
                paymentId: paymentId,
                paymentAccount: paymentAccount,
                withheldCode: withheldCode,
                isDraft: !validForPassiveInvoice,
                createdAt: createdAt ? moment__WEBPACK_IMPORTED_MODULE_0___default()(createdAt, "YYYY-MM-DD").format("L") : "",
                updatedAt: updatedAt ? moment__WEBPACK_IMPORTED_MODULE_0___default()(updatedAt, "YYYY-MM-DD").format("L") : ""
            };
        }).sort(function(a, b) {
            return a.isDefault ? -1 : b.isDefault ? 1 : "".concat(a.label).localeCompare(b.label);
        })
    };
});
var selectDefaultBillingProfile = (0,reselect__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(selectBillingProfiles, function(param) {
    var profiles = param.profiles;
    if (profiles.length === 0) return {
        paymentAccount: {}
    };
    return profiles.find(function(billingProfile) {
        return billingProfile.isDefault;
    });
});
var selectBillingFormErrors = (0,reselect__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(function(state) {
    return state.billing.errors;
}, function(payload) {
    var errors = {};
    if (payload && payload.status === "CUSTOM-ERROR") {
        payload.data.errors.forEach(function(param) {
            var type = param.type, detail = param.detail;
            var field = type.split(":")[1];
            errors = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, errors), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, field, detail));
        });
    }
    return errors;
});
var selectPaymentFormErrors = (0,reselect__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(function(state) {
    return state.billing.errors;
}, function(payload) {
    var errors = {};
    if (payload && payload.status === "CUSTOM-ERROR") {
        payload.data.errors.forEach(function(param) {
            var type = param.type, detail = param.detail;
            var field = type.split(":")[1];
            errors = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, errors), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, field, detail));
        });
    }
    return errors;
});
var selectDocumentPassive = (0,reselect__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(function(state) {
    return state.billing.document;
}, _config__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, function(payload, param) {
    var languageCode = param.languageCode;
    if (!payload) {
        return {
            rows: [],
            timeline: [],
            companyInfo: {}
        };
    }
    var _invoice = payload.invoice, billingProfilePid = _invoice.billingProfilePid, _data = _invoice.data, pid = _data.id, _attributes = _data.attributes, typologyCode = _attributes.typologyCode, issuedNumber = _attributes.issuedNumber, issuedOn = _attributes.issuedOn, issuableNumber = _attributes.issuableNumber, issuableOn = _attributes.issuableOn, status = _attributes.status, currencyCode = _attributes.currencyCode, rows = _attributes.rows, footer = _attributes.footer, amount = _attributes.amount, companyInfo = _attributes.companyInfo, timeline = _attributes.timeline, minIssuableOn = _attributes.minIssuableOn, approvedOn = _attributes.approvedOn, approvedOnSelector = _attributes.approvedOnSelector, permissions = _attributes.permissions, synthetic = _attributes.synthetic, ripartition = _attributes.ripartition, downloadPdf = _data.links.downloadPdf;
    if (typologyCode !== "PASSIVE") {
        return {
            rows: [],
            timeline: [],
            companyInfo: {}
        };
    }
    moment__WEBPACK_IMPORTED_MODULE_0___default().locale(languageCode);
    var _billingProfile = payload.billingProfile, _data1 = _billingProfile.data, _attributes1 = _data1.attributes, label = _attributes1.label, appellation = _attributes1.appellation, address = _attributes1.address, city = _attributes1.city, postalCode = _attributes1.postalCode, countrySub = _attributes1.countrySub, countryCode = _attributes1.countryCode, personalTin = _attributes1.personalTin, companyTin = _attributes1.companyTin, billingModeCode = _attributes1.billingModeCode;
    var _paymentAccount = payload.paymentAccount, _data2 = _paymentAccount.data, paymentMethodCode = _data2.attributes.paymentMethodCode;
    var objectRows = {};
    rows.forEach(function(row) {
        var key = moment__WEBPACK_IMPORTED_MODULE_0___default()(row.period.name, "YYYY-MM").format("MMM YYYY");
        objectRows = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, objectRows), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, key, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, objectRows[key]), {
            title: key,
            partialRight: objectRows[key] ? Number(objectRows[key].partialRight) + Number(row.amount) : Number(row.amount),
            data: []
        })));
    });
    rows.forEach(function(row) {
        var key = moment__WEBPACK_IMPORTED_MODULE_0___default()(row.period.name, "YYYY-MM").format("MMM YYYY");
        var id = (0,uuid__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)();
        objectRows = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, objectRows), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, key, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, objectRows[key]), {
            title: key,
            right: (0,lib_format_currency__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(currencyCode, objectRows[key].partialRight),
            data: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(objectRows[key].data).concat([
                {
                    id: id,
                    key: id,
                    month_of_sale: moment__WEBPACK_IMPORTED_MODULE_0___default()(row.period.name, "YYYY-MM").format("MMM YYYY").toUpperCase(),
                    publisher: row.publisher && row.publisher.name ? row.publisher.name : null,
                    store_name: row.store && row.store.name ? row.store.name : null,
                    item_type: row.itemType && row.itemType.code ? row.itemType.code.toLowerCase() : null,
                    currency: row.currency && row.currency.code ? row.currency.code : null,
                    currencyAmount: (0,lib_format_currency__WEBPACK_IMPORTED_MODULE_5__/* .formatCurrencyWithLanguage */ .g)(row.currency.code, row.originalAmount),
                    amount: (0,lib_format_currency__WEBPACK_IMPORTED_MODULE_5__/* .formatCurrencyWithLanguage */ .g)(currencyCode, row.amount),
                    fxRate: row.fxRate,
                    floatAmount: row.amount,
                    ruleExtid: row.ruleExtid,
                    recipientSlid: row.recipientSlid,
                    note: row.note
                }, 
            ])
        })));
    });
    var _toPayAmount, _amount, _amount1, _amount2, _amount3, _amount4;
    return {
        pid: pid,
        id: pid,
        billingProfileLabel: label,
        appellation: appellation,
        address: address,
        city: city,
        postalCode: postalCode,
        countrySub: countrySub,
        countryCode: countryCode,
        personalTin: personalTin,
        companyTin: companyTin,
        billingModeCode: billingModeCode,
        issuableNumber: issuableNumber,
        issuableOn: issuableOn,
        issuedNumber: issuedNumber,
        permissions: permissions,
        synthetic: synthetic,
        ripartition: ripartition,
        approvedOnSelector: approvedOnSelector,
        approvedOn: approvedOn ? moment__WEBPACK_IMPORTED_MODULE_0___default()(approvedOn, "YYYY-MM-DD").format("L") : issuedOn ? moment__WEBPACK_IMPORTED_MODULE_0___default()(issuedOn, "YYYY-MM-DD").format("L") : "",
        issuedOn: issuedOn ? moment__WEBPACK_IMPORTED_MODULE_0___default()(issuedOn, "YYYY-MM-DD").format("L") : "",
        subTotal: (0,lib_format_currency__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(currencyCode, amount !== null && amount !== void 0 ? amount : 0),
        total: (0,lib_format_currency__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(currencyCode, (_toPayAmount = footer.toPayAmount) !== null && _toPayAmount !== void 0 ? _toPayAmount : 0),
        paymentMethod: footer.paymentSummary ? footer.paymentSummary.paymentMethodCode : null,
        paymentMethodRecipient: footer.paymentSummary && footer.paymentSummary.recipient ? footer.paymentSummary.recipient.value : null,
        paymentMethodCode: paymentMethodCode,
        pension: footer.pension.amount ? (0,lib_format_currency__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(currencyCode, (_amount = footer.pension.amount) !== null && _amount !== void 0 ? _amount : 0) : null,
        pensionFormula: footer.pension.formula || null,
        fees: footer.paymentFee.amount ? (0,lib_format_currency__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(currencyCode, (_amount1 = footer.paymentFee.amount) !== null && _amount1 !== void 0 ? _amount1 : 0) : null,
        stamp: footer.stamp.amount ? (0,lib_format_currency__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(currencyCode, (_amount2 = footer.stamp.amount) !== null && _amount2 !== void 0 ? _amount2 : 0) : null,
        withheld: footer.withheld.amount ? (0,lib_format_currency__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(currencyCode, (_amount3 = footer.withheld.amount) !== null && _amount3 !== void 0 ? _amount3 : 0) : null,
        vat: footer.vat.amount ? (0,lib_format_currency__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(currencyCode, (_amount4 = footer.vat.amount) !== null && _amount4 !== void 0 ? _amount4 : 0) : (0,lib_format_currency__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(currencyCode, 0),
        vatAmount: footer.vat.amount || 0,
        vatFormula: footer.vat.formula ? "(".concat(footer.vat.formula, ")") : "",
        vatMessage: footer.vat.message ? "(".concat(footer.vat.message, ")") : "",
        vatCode: footer.vat.code ? "(".concat(footer.vat.code, ")") : "",
        formula: footer.withheld.formula ? "(".concat(footer.withheld.formula, ")") : "",
        rows: Object.keys(objectRows).map(function(key) {
            return objectRows[key];
        }),
        companyInfo: companyInfo,
        status: status === "DRAFT" ? "DRAFT" : "PASSIVE",
        timeline: timeline !== null && timeline !== void 0 ? timeline : [],
        minIssuableOn: minIssuableOn ? moment__WEBPACK_IMPORTED_MODULE_0___default()(minIssuableOn, "YYYY-MM-DD") : null,
        invoiceLink: downloadPdf,
        billingProfilePid: billingProfilePid
    };
});
var selectDocumentActive = (0,reselect__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(function(state) {
    return state.billing.document;
}, function(payload) {
    if (!payload) {
        return {
            rows: [],
            timeline: [],
            companyInfo: {}
        };
    }
    var _invoice = payload.invoice, pid = _invoice.id, _data = _invoice.data, _attributes = _data.attributes, paymentMethod = _attributes.paymentMethod, typologyCode = _attributes.typologyCode, issuedNumber = _attributes.issuedNumber, imsDocumentRegNumber = _attributes.imsDocumentRegNumber, issuedOn = _attributes.issuedOn, currencyCode = _attributes.currencyCode, rows = _attributes.rows, totalAmount = _attributes.totalAmount, netAmount = _attributes.netAmount, timeline = _attributes.timeline, companyInfo = _attributes.companyInfo, vatAmount = _attributes.vatAmount, downloadPdf = _data.links.downloadPdf;
    if (typologyCode !== "ACTIVE") {
        return {
            rows: [],
            timeline: [],
            companyInfo: {}
        };
    }
    var _billingProfile = payload.billingProfile, _data1 = _billingProfile.data, _attributes1 = _data1.attributes, label = _attributes1.label, appellation = _attributes1.appellation, address = _attributes1.address, city = _attributes1.city, postalCode = _attributes1.postalCode, countrySub = _attributes1.countrySub, countryCode = _attributes1.countryCode, personalTin = _attributes1.personalTin, companyTin = _attributes1.companyTin, billingModeCode = _attributes1.billingModeCode;
    var parsedRows = rows.map(function(row) {
        var id = (0,uuid__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)();
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, row), {
            key: id,
            currency: currencyCode,
            unitPrice: (0,lib_format_currency__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(currencyCode, row.unitPrice),
            isDiscount: row.unitPrice < 0
        });
    });
    return {
        pid: pid,
        id: pid,
        billingModeCode: billingModeCode,
        paymentMethodCode: paymentMethod,
        billingProfileLabel: label,
        appellation: appellation,
        address: address,
        city: city,
        postalCode: postalCode,
        countrySub: countrySub,
        countryCode: countryCode,
        personalTin: personalTin,
        companyTin: companyTin,
        issuedNumber: issuedNumber,
        imsDocumentRegNumber: imsDocumentRegNumber,
        issuedOn: issuedOn ? moment__WEBPACK_IMPORTED_MODULE_0___default()(issuedOn, "YYYY-MM-DD").format("L") : "",
        vatAmount: (0,lib_format_currency__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(currencyCode, vatAmount !== null && vatAmount !== void 0 ? vatAmount : 0),
        subTotal: (0,lib_format_currency__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(currencyCode, netAmount !== null && netAmount !== void 0 ? netAmount : 0),
        total: (0,lib_format_currency__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(currencyCode, totalAmount !== null && totalAmount !== void 0 ? totalAmount : 0),
        rows: parsedRows,
        status: "ACTIVE",
        timeline: timeline !== null && timeline !== void 0 ? timeline : [],
        companyInfo: companyInfo,
        invoiceLink: downloadPdf
    };
});
var selectLastWithdrawal = (0,reselect__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(function(state) {
    return state.billing.lastWithdrawal;
}, _config__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, function(payload, param) {
    var languageCode = param.languageCode;
    if (!payload || !(payload === null || payload === void 0 ? void 0 : payload.data)) return {
        status: "processed"
    };
    moment__WEBPACK_IMPORTED_MODULE_0___default().locale(languageCode);
    var _data = payload.data, _attributes = _data.attributes, id = _attributes.id, customerCode = _attributes.customerCode, failureDescription = _attributes.failureDescription, nextAt = _attributes.nextAt, processedAt = _attributes.processedAt, requestedAt = _attributes.requestedAt, status = _attributes.status, translatedStatus = _attributes.translatedStatus;
    return {
        id: id,
        customerCode: customerCode,
        failureDescription: failureDescription,
        nextAt: moment__WEBPACK_IMPORTED_MODULE_0___default()(nextAt).format("L"),
        processedAt: moment__WEBPACK_IMPORTED_MODULE_0___default()(processedAt).format("L"),
        requestedAt: moment__WEBPACK_IMPORTED_MODULE_0___default()(requestedAt).format("L"),
        status: status,
        translatedStatus: translatedStatus
    };
});
/* harmony default export */ __webpack_exports__["ZP"] = (selectSummary);



/***/ })

}]);